import styled from 'styled-components'
import { Link } from 'gatsby'
import { Box } from '@material-ui/core'

export const Wrapper = styled(Box)`
  width: 400px;
  margin: 20px 10px 20px 0;
  padding: 20px;
  display: inline-block;
   @media (max-width: 661px) {
    & {
      width: 100%;
    }
  }
  & > img {
    width: 400px;
    height: 267px;
  }
  & .MuiContainer-root {
    display: flex;
    justify-content: center;
  }
  & .MuiContainer-root img {
    width: 80%;
  }
`

export const SlideLink = styled(Link)`
  border: 2px solid;
  padding: 15px;
  border-radius: 12px;
`

export const CourseBody = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
  align-items: center;

  & > a {
    color: rgb(41, 41, 41);
    font-size: 20px;
    text-align: center;
  }

  & > div {
    display: flex;
    width: 100%;
    margin-top: 20px;
  }

  & div:nth-child(3) {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  ul {
    width: 100%;
    margin-top: 25px;
  }

  li {
    list-style: none;
    display: flex;
    align-items: center;
    margin: 5px 0;
  }

  span {
    margin-left: 7px;
    font-size: 16px;
  }
`

export const SubscribeBtn = styled.a`
  font-size: 19px;
  border: 2px solid #00ae9c;
  padding: 12px;
  border-radius: 5px;
  background: #00ae9c;
  color: #fff;

  &:hover {
    color: #fff;
  }
`
export const ReadBtn = styled.a`
  color: #ef4e45;
  font-weight: 600;
`
